export default __webpack_public_path__ + "static/icon-af9ba18709c4a725fab24efbec3c10d2.png";